// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".civic-input[data-v-d6303cc0]{width:90px;float:left}.postal-fields[data-v-d6303cc0]{width:50%}.error-message[data-v-d6303cc0]{text-align:center;color:#d0021b}", ""]);
// Exports
module.exports = exports;
